import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    error: null,
    listInvoice: [],
    dataBase64: '',
    responseReprocess: [],
    responseUnlockInvoice: [],
    responseEmail: null,
    listClients: [],
    runListInvoice: false,
    syncResponse: null,
  },
  getters: {},
  mutations: {

    resetListInvoice (state) {
      state.listInvoice = { Mensaje: [] }
    },

    setListClients (state, data) {
      state.listClients = data
    },

    setListInvoice (state, data) {
      state.listInvoice = data
      state.error = null
    },
    setDataPDFBase64 (state, data) {
      state.dataBase64 = data
      state.error = null
    },
    setResponseReprocess (state, data) {
      state.responseReprocess = data
      state.error = null
    },
    setResponseUnlockInvoice (state, data) {
      state.responseUnlockInvoice = data
    },
    setResponseEmail (state, data) {
      state.responseEmail = data
      state.error = null
    },
    setRunListInvoice (state, data) {
      state.runListInvoice = data
    },
    setSyncResponse(state, data) {
      state.syncResponse = data
      state.error = null
    },
  },
  actions: {
    getListInvoice ({ commit }, data) {
      let params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania

      if (!data) {
        let dateCurrent = new Date()
        dateCurrent = dateCurrent.getFullYear() + '-' + String(dateCurrent.getMonth() + 1).padStart(2, '0') + '-' + String(dateCurrent.getDate()).padStart(2, '0')
        params += `&FechaInicial= ${dateCurrent}`
        params += `&FechaFinal= ${dateCurrent}`
      } else {
        if (data.ProveedorTecnologico) {
          params += `&ProveedorTecnologico=${data.ProveedorTecnologico}`
        }
        if (data.Consecutivo) {
          params += `&ConsecutivoDocumento= ${data.Consecutivo}`
        }
        if (data.Status && data.Status !== '') {
          params += `&Estado= ${data.Status}`
        }
        if (data.Prefix) {
          params += `&Prefijo= ${data.Prefix}`
        }
        if (data.origin) {
          params += `&OriginTransacion= ${data.origin}`
        }

        if (data.dates) {
          let startDate
          let endDate

          if (Array.isArray(data.dates)) {
            if (data.dates.length === 2) {
              [startDate, endDate] = data.dates
            } else if (data.dates.length === 1) {
              startDate = endDate = data.dates[0]
            }
          } else {
            // 👈 Caso: viene una sola fecha (string)
            startDate = endDate = data.dates
          }

          if (startDate && endDate) {
            params += `&FechaInicial=${startDate}`
            params += `&FechaFinal=${endDate}`
          }
        }

        if (data.IdCompania) {
          params += `&IdCompania=${data.IdCompania}`
        }
      }
      
      const endpoint = '/api/getInvoices?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListInvoice', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    reprocessInvoice ({ commit }, data) {
      let params = ''
      params += `consecutivoDocumento=${data.CosecutivoDocumento}`
      params += `&idCompania=${data.IdCompania}`
      params += '&PlantillaPdfHKA=co-default-21-propina-40'

      if (data.ProveedorTecnologico === 2) {
        params += '&proveedor=EDN'
      }

      const endpoint = '/api/sincronizarFEPendientes?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setResponseReprocess', response.data.respuesta)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    unlockInvoice ({ commit }, data) {
      let params = ''
      params += `consecutivoDocumento=${data.CosecutivoDocumento}`
      params += `&idCompania=${data.IdCompania}`
      params += `&idFactura=${data.IdFactura}`
      params += `&usuario=${JSON.parse(atob(localStorage.getItem('uid'))).user}`

      const endpoint = '/api/desbloquearDocumento?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setResponseUnlockInvoice', response.data.respuesta)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getDataPDF ({ commit }, data) {
      let params = ''
      params += `consecutivoDocumento= ${data.CosecutivoDocumento}`
      params += `&idCompania= ${data.IdCompania}`

      const endpoint = '/api/descargarPDF?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          commit('setDataPDFBase64', response.data.respuesta)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },

    getDataPDFEDN ({ commit }, data) {
      let params = ''
      params += `&idCompania= ${data.IdCompania}`
      params += `&IdFactura= ${data.IdFactura}`

      const endpoint = '/api/descargarPDFEDN?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          console.log('PPPPPP')
          console.log(response.data)
          commit('setDataPDFBase64', response.data)
        })
        .catch(function (error) {
          commit('setDataPDFBase64', false)
          console.log(error.message)
        })
    },

    sendEmail ({ commit }, data) {
      let params = ''
      params += `consecutivoDocumento= ${data.CosecutivoDocumento}`
      params += `&idCompania= ${data.IdCompania}`
      params += `&email= ${data.email}`

      const endpoint = '/api/enviarCorreo?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setResponseEmail', response.data.respuesta)
        })
        .catch(function (error) {
          commit('setResponseEmail', null)
          console.log(error.message)
        })
    },
    sincronizar({ commit }, data) {
      let params = '';
      if (data.fecha) params += `fecha=${data.fecha}&`;
      if (data.enviarConFechaActual !== undefined) params += `enviarConFechaActual=${data.enviarConFechaActual}&`;
      if (data.IdCompania) params += `idCompania=${data.IdCompania}&`;
      if (data.CosecutivoDocumento) params += `consecutivoDocumento=${data.CosecutivoDocumento}&`;

      if (data.ProveedorTecnologico === 2) {
        params += '&proveedor=EDN'
      }
      const endpoint = '/api/sincronizarFEPendientes?';
      const url = environment.HIOPOSWEBSERVICES + endpoint + params;
      return axios
        .create()
        .get(url)
        .then(response => {
          const respuesta = response.data.respuesta;
          commit('setSyncResponse', respuesta);
          return respuesta;
        })
        .catch(function (error) {
          console.error('Error', error.message);
          const errorResponse = { Error: true, Mensaje: error.message };
          commit('setSyncResponse', errorResponse);
          throw errorResponse;
        });
    },

    sincronizarPorRangos({ commit }, data) {
      let params = '';

      if (data.IdCompania) params += `idCompania=${data.IdCompania}&`;
      if (data.fecha) params += `fecha=${data.fecha}&`;
      if (data.fechaFin) params += `fechaFin=${data.fechaFin}&`;

      if (data.documentRangeStart !== null && data.documentRangeEnd !== null) {
        params += `rangoDocumentos=${data.serie}-${data.documentRangeStart}-${data.documentRangeEnd}&`;
      }

      if (data.resolutionRangeStart !== null && data.resolutionRangeEnd !== null) {
        params += `rangoResolucion=${data.serie}(Desde ${data.resolutionRangeStart} Hasta ${data.resolutionRangeEnd})`;
      }

      if (data.proveedorTecnologico === '2') {
        params += '&proveedor=EDN'
      }
      const endpoint = '/api/sincronizarFEPendientes?';
      const url = environment.HIOPOSWEBSERVICES + endpoint + params;

      return axios
        .create()
        .get(url)
        .then(response => {
          const respuesta = response.data.respuesta;
          commit('setSyncResponse', respuesta);
          return respuesta;
        })
        .catch(error => {
          console.error('Error:', error.message);
          const errorResponse = { Error: true, Mensaje: error.message };
          commit('setSyncResponse', errorResponse);
          throw errorResponse;
        });
    },

    setResponseEmail ({ commit }, data) {
      commit('setResponseEmail', data)
    },
    setResponseUnlockInvoiceData ({ commit }, data) {
      commit('setResponseUnlockInvoice', data)
    },
    setRunListInvoiceData ({ commit }, data) {
      commit('setRunListInvoice', data)
    },

  },
}
